module.exports = __webpack_public_path__ + "static/media/7.bf387362.jpg";